import React from 'react';

/**
 * Minimales Seitengerüst: nur Hintergrund + voller Platz.
 *
 * Bewusst KEIN globaler Header/Footer mehr — Projekte werden im Vollbild
 * geöffnet. Jede Seite bringt ihr eigenes Layout mit (die Übersicht zentriert
 * ihren Inhalt, Projektseiten nutzen die volle Fläche + „← Übersicht"-Button).
 */
export default function Layout({ children }) {
  return (
    <div className="relative min-h-full bg-paper text-ink-soft">
      {/* Dezenter, warmer Farbverlauf im Hintergrund */}
      <div className="pointer-events-none fixed inset-0 -z-20 bg-[radial-gradient(70%_60%_at_50%_-10%,rgba(28,26,22,0.07),transparent_70%)]" />
      {children}
    </div>
  );
}
